import React from "react";
import { FieldTypeIcon } from "../../atoms/FieldTypeIcon";
import type { FieldTypeIconKind } from "../../registry/fieldTypeIcons";
import { rawColors } from "../../../design-system/tokens/colors";
import { TypeBadge } from "./storyFilterColumnIcon.styles";
import type { StoryFilterColumnType } from "./StoryFilterBar.types";

const BADGE_ICON_SIZE = 12;

/** Badge tint per column type: measures info blue, calculations secondary, dates warning, dimensions primary, geographic green. */
const BADGE_TINTS: Record<StoryFilterColumnType, string> = {
  number: rawColors.accent.infoBlue.bg,
  measure: rawColors.secondary[100],
  date: rawColors.accent.peachLight,
  text: rawColors.primary[100],
  geo: rawColors.accent.greenLight,
};

/**
 * The filter API's column types predate the shared field-type registry; the
 * sigma it calls "measure" is the registry's "calculated" glyph.
 */
const COLUMN_TYPE_TO_ICON_KIND: Record<StoryFilterColumnType, FieldTypeIconKind> = {
  date: "date",
  text: "text",
  geo: "geo",
  number: "number",
  measure: "calculated",
};

/** Coloured type glyph on a tinted 18px badge for a column-dropdown row — glyph and colour come from `fieldTypeIcons`. */
export const storyFilterColumnIcon = (type: StoryFilterColumnType): React.ReactNode => (
  <TypeBadge $tint={BADGE_TINTS[type]} data-testid={`story-filter-column-badge-${type}`}>
    <FieldTypeIcon
      kind={COLUMN_TYPE_TO_ICON_KIND[type]}
      size={BADGE_ICON_SIZE}
      testId={`story-filter-column-icon-${type}`}
    />
  </TypeBadge>
);
